import React, { useContext, useEffect, useState } from 'react';
import { Box, Flex, Text } from '@chakra-ui/layout';
import ProfileThumbnail from '../../../profile/component/profileThumbnail';
import { MdArrowDropDown } from 'react-icons/md';
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/menu';
import { Button, Skeleton, Tag, TagLabel } from '@chakra-ui/react';
import roleDictionnary from '../../../lib/roleDictionnary';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import memberStatusDictionnary from '../../../lib/memberStatusDictionnary';
import { ProfileContext } from '../../../profile/lib/profileContext';
import { AuthContext } from '../../../auth/lib/authContext';
import useProfileApi from '../../../profile/lib/useProfileApi';
import { useNavigate } from 'react-router-dom';
export default function SharedExperienceMemberListItem(props) {
  const { profile } = useContext(ProfileContext);
  const { profile: authProfile } = useContext(AuthContext);
  const {
    sharedExperienceId,
    onRevoke,
    onRoleUpdated
  } = props;
  const navigate = useNavigate();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const profileApi = useProfileApi();
  const [profileId, setProfileId] = useState();
  const [newProfileId, setNewProfileId] = useState();
  const [itemRole, setItemRole] = useState();
  const [approving, setApproving] = useState(false);
  const [fetchingData, setFetchingData] = useState(false);
  const [role, setRole] = useState();
  const [hasRequestedEdition, setHasRequestedEdition] = useState();
  const [status, setStatus] = useState();
  const [email, setEmail] = useState();
  const fetchData = async () => {
    try {
      setFetchingData(true);
      const promises = [
        sharedExperiencesApi.fetchMemberRole(sharedExperienceId, profile.id),
        sharedExperiencesApi.fetchMemberStatus(sharedExperienceId, profile.id),
        sharedExperiencesApi.hasRequestedEdition(sharedExperienceId, profile.id),
        sharedExperiencesApi.fetchMemberRole(sharedExperienceId, authProfile.id),
        profileApi.fetchEmailByProfileId(profile.id)
      ];
      const result = await Promise.all(promises);
      setItemRole(result[0]);
      setStatus(result[1]);
      setHasRequestedEdition(result[2]);
      setRole(result[3]);
      setEmail(result[4]);
      setFetchingData(false);
    } catch (e) {
      console.error(e);
    }
  };
  const updateRole = async (role) => {
    try {
      await sharedExperiencesApi.updateRole(sharedExperienceId, profile.id, role);
      if (onRoleUpdated) {
        onRoleUpdated();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const revokeAccess = async () => {
    try {
      await sharedExperiencesApi.revokeAccess(sharedExperienceId, profile.id);
      if (onRevoke) {
        onRevoke();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const leave = async () => {
    try {
      await sharedExperiencesApi.revokeAccess(sharedExperienceId, authProfile.id);
      navigate('/shared-experiences');
    } catch (error) {
      console.error(error);
    }
  };
  const approveRequest = async () => {
    try {
      setApproving(true);
      if (hasRequestedEdition) {
        await sharedExperiencesApi.approveRequest(sharedExperienceId, profile.id);
      } else {
        await sharedExperiencesApi.approveMemberRequest(sharedExperienceId, profile.id);
      }
      setApproving(false);
      if (onRoleUpdated) {
        onRoleUpdated();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const declineRequest = async () => {
    try {
      if (hasRequestedEdition) {
        await sharedExperiencesApi.declineRequest(sharedExperienceId, profile.id);
      } else {
        await sharedExperiencesApi.declineMemberRequest(sharedExperienceId, profile.id);
      }
      if (onRoleUpdated) {
        onRoleUpdated();
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (profileId) {
      fetchData();
    }
  }, [profileId]);
  useEffect(() => {
    if (newProfileId !== profileId) {
      setProfileId(newProfileId);
    }
  }, [newProfileId]);
  useEffect(() => {
    if (profile.id && sharedExperienceId && authProfile) {
      setNewProfileId(profile.id);
    }
  }, [profile.id, sharedExperienceId, authProfile]);
  return (
    <>
      {profile && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          px={3}
          py={3}
          backgroundColor="white"
        >
          <Flex alignItems={'center'}>
            <ProfileThumbnail size={40} />
            <Flex ml={2} flexDirection={"column"}>
              <Text>{profile.pseudo} {authProfile.id === profile.id ? '(Me)' : ''} </Text>
              {email && <Text fontSize={"11px"} color="text.medium.grey">{email}</Text>}
            </Flex>
          </Flex>
          <Flex flexDirection={"column"} alignItems={"flex-end"}>
            {fetchingData && <Skeleton width={"100px"} height={"30px"}/>}
            {status === memberStatusDictionnary.approved && (
              <>
                {((itemRole && itemRole !== roleDictionnary.owner)
                  && (role && role === roleDictionnary.owner)) && (
                    <Menu ml={2} >
                      {({ isOpen }) => (
                        <>
                          <MenuButton
                            isActive={isOpen}
                            as={Button}
                            rightIcon={<MdArrowDropDown />}
                            variant='transparent'
                            width={"fit-content"}
                            textTransform={'capitalize'}
                          >{itemRole}</MenuButton>
                          <MenuList>
                            {hasRequestedEdition &&
                              (<>
                                <MenuItem onClick={approveRequest} >
                                  <Text color='text.medium.green' >Approve Edition Request</Text>
                                </MenuItem>
                                <MenuItem onClick={declineRequest} >
                                  <Text color='text.medium.red' >Decline Edition Request</Text>
                                </MenuItem>
                              </>
                              )}
                            {(itemRole && itemRole !== roleDictionnary.contributor) && <MenuItem onClick={() => { updateRole(roleDictionnary.contributor) }} >Contributor</MenuItem>}
                            {(itemRole && itemRole !== roleDictionnary.viewer) && <MenuItem onClick={() => { updateRole(roleDictionnary.viewer) }}>Viewer</MenuItem>}
                            <MenuItem onClick={revokeAccess} >
                              <Text color='text.medium.red' >Revoke Access</Text>
                            </MenuItem>
                          </MenuList>
                        </>
                      )}
                    </Menu>
                  )}
                {((
                  itemRole && itemRole === roleDictionnary.owner)
                  || (role && role !== roleDictionnary.owner)
                  || !role)
                  && (
                    <>
                      {(profile.id !== authProfile.id
                        || (itemRole && itemRole === roleDictionnary.owner))
                        &&
                        <Text
                          textTransform={'capitalize'}
                          color="text.tertiaryGrey"
                        >{itemRole}</Text>
                      }
                      {(profile.id === authProfile.id
                        && itemRole && itemRole !== roleDictionnary.owner)
                        &&
                        <Menu ml={2} >
                          {({ isOpen }) => (
                            <>
                              <MenuButton
                                isActive={isOpen}
                                as={Button}
                                rightIcon={<MdArrowDropDown />}
                                variant='transparent'
                                p={0}
                                width={"fit-content"}
                                textTransform={'capitalize'}
                              >{itemRole}</MenuButton>
                              <MenuList>
                                <MenuItem onClick={leave}>
                                  <Text color='text.medium.red' >Leave</Text>
                                </MenuItem>
                              </MenuList>
                            </>
                          )}
                        </Menu>
                      }
                    </>
                  )}
              </>
            )}
            {(role !== roleDictionnary.owner && status === memberStatusDictionnary.requested) && (
              <>
                <Tag variant="orange">
                  <TagLabel>Requested</TagLabel>
                </Tag>
              </>
            )}
            {(role === roleDictionnary.owner && status === memberStatusDictionnary.requested) && (
              <Box mt={2}>
                <Button variant="greenFill"
                  onClick={approveRequest}
                  isLoading={approving}>Approve</Button>
                <Button ml={1} variant="redFill" onClick={declineRequest}>Decline</Button>
              </Box>
            )}
          </Flex>
        </Flex>
      )}
    </>
  );
} 